module.exports = __webpack_public_path__ + "img/service-bills.b46b0728.svg";